$(document).ready(function () {
  $('.marquee-left').marquee({
    direction: 'left',
    duration: 40000,
    delayBeforeStart: 0,
    duplicated: true,
    gap: 0,
    startVisible: true
  });

  $('.banner-list').slick({
    arrows: false,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    adaptiveHeight: true
  });

  $('.custome-slider-button .slick-prev').click(function () {
    $('.' + $(this).attr('data-slider-name')).slick('slickPrev');
  });

  $('.custome-slider-button .slick-next').click(function () {
    $('.' + $(this).attr('data-slider-name')).slick('slickNext');
  });

  $(".products-slider .product-list").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 880,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      }
    ]
  });

});

// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function (k, v) {
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function () {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#" + activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");

  $('.product-list').slick('refresh');

});
/* if in drawer mode */
$(".tab_drawer_heading").click(function () {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#" + d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");

  $('.product-list').slick('refresh');
});


/* Extra class "tab_last"
   to add border to right side
   of last tab */
$('ul.tabs li').last().addClass("tab_last");


// mobile Tab
$(document).on('click', '.select-label', function () {
  if ($(this).parent().hasClass('active')) {
    $(this).parent().removeClass('active');
  } else {
    $('.dropdown').removeClass('active');
    $(this).parent().addClass('active');
  }
});
$(document).on('click', '.dropdown-list li', function () {
  $(this).parents('.dropdown').find('.select-label_inner').text($(this).text());
  $(this).parents('.dropdown').removeClass('active');
  var variant_id = $(this).data('value');
  $(this).parents('.main_variant_div').parent().find('.product-variant-id').val(variant_id);
});


// popup

$(document).ready(function () {

  $('.sm_open').on('click', function () {
    var modal = $(this).attr('data-modal');
    var modaloverlaycolor = $(this).attr('data-overlay');
    var modaleffect = $(this).attr('data-effect');
    var modalheader = $(this).attr('data-header');
    var modalheadertype = $(this).attr('data-header-type');
    var modalcontent = $(this).attr('data-content');
    var modaliconside = $(this).attr('data-icons');
    var modalwrappercolor = $(this).attr('data-wrapper-color');

    $('#' + modal).addClass(modaloverlaycolor);
    $('#' + modal + ' .sm_content').addClass(modaleffect);
    $('#' + modal + ' .sm_content .sm_header').html(modalheader);
    $('#' + modal + ' .sm_content .sm_header').addClass(modalheadertype);
    $('#' + modal + ' .sm_content .sm_area_all').html(modalcontent);
    $('#' + modal + ' .sm_icon_menu').addClass(modaliconside);
    $('#' + modal + ' .sm_content').addClass(modalwrappercolor);
    $('#' + modal).fadeIn().css("display", "flex");
    setTimeout(function () {
      $('#' + modal + ' .sm_content').addClass('show');
    }, 400);
  });

  $('.sm_close').on('click', function () {
    var $modal = $(this).parents('.slim_modal');
    closeModal($modal);
  });

  $('.slim_modal').on('click', function (e) {
    if (e.target !== this)
      return;
    var $modal = $(this);
    closeModal($modal);
  });

  function closeModal($modal) {
    $modal.find('.sm_content').removeClass('show');
    setTimeout(function () {
      $modal.removeClass('red green tan none');
      $modal.find('.sm_content').removeClass('red green tan');
      $modal.find('.sm_icon_menu').removeClass('is_right is_left');
      $modal.find('.sm_header').removeClass('detached');
      $modal.fadeOut();
    }, 400);
  }
});


// grid list view handler
document.addEventListener('click', function (e) {
  const viewBtn = e.target.closest('.custom_grid_list_view .custom_view_layout');

  if (!viewBtn) return;

  document.querySelectorAll('.custom_grid_list_view .custom_view_layout')
    .forEach((btn) => btn.classList.remove('active'));

  viewBtn.classList.add('active');

  const viewType = viewBtn.dataset.view;

  const productContainer = document.getElementById('product-grid');
  const searchProductGrid = document.querySelector('#ProductGridContainer .product-grid');

  [productContainer, searchProductGrid].forEach((grid) => {
    if (!grid) return;

    if (viewType === 'list') {
      grid.classList.remove('grid');
      grid.classList.add('list_view', 'flex');
    } else {
      grid.classList.add('grid');
      grid.classList.remove('list_view', 'flex');
    }
  });
});

// collection page custom shop by filter
// document.querySelectorAll('.medals_necklaces_items .custom_shop_by').forEach((select) => {
//   select.addEventListener('change', function () {
//     const value = this.value;
//     const filterType = this.dataset.filterType;
//     document.querySelector(`input[name="${CSS.escape(filterType)}"][value="${CSS.escape(value)}"]`)?.click();
//   });
// });

document.addEventListener("DOMContentLoaded", () => {

  function setInActiveShopBy() {
    document.querySelectorAll('.shopby_custom_filter.active').forEach(el => {
      el.classList.remove('active');
    });
  }

  document.addEventListener('click', (e) => {
    const shopBy = e.target.closest('.shopby_custom_filter');
    const shopByContainer = e.target.closest('.shopby_custom');

    if (shopBy) {
      const isActive = shopBy.classList.contains('active');

      setInActiveShopBy();

      if (!isActive) {
        shopBy.classList.add('active');
      }

    } else if (!shopByContainer) {
      setInActiveShopBy();
    }
  });


  // =====================================================
  // SHOP BY FILTERS
  // Supports combining multiple filters
  // =====================================================

  document.addEventListener('click', function (e) {

    const shopByOption = e.target.closest(
      '.custom_shop_by .shopby_option'
    );

    if (!shopByOption) return;

    // Ignore empty/default options
    if (shopByOption.classList.contains('shopby_option--empty')) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const parent = shopByOption.closest('.custom_shop_by');
    const parentShopBy = shopByOption.closest('.shopby_custom');

    if (!parent || !parentShopBy) return;

    const filterType = parent.dataset.filterType;
    const selectedValue = shopByOption.dataset.value;

    if (!filterType || !selectedValue) {
      console.warn('Missing filter information:', {
        filterType,
        selectedValue
      });
      return;
    }

    const valueSpan = parentShopBy.querySelector('.value');

    const isActive = shopByOption.classList.contains('active');

    // ---------------------------------------------------
    // Remove active only from THIS dropdown
    // ---------------------------------------------------

    // parent.querySelectorAll('.shopby_option.active').forEach(option => {
    //   option.classList.remove('active');
    // });


    // const checkbox = shopByOption.querySelector('input[type="checkbox"]');

    // if (checkbox) {
    //   checkbox.checked = !checkbox.checked;
    // }

    // ---------------------------------------------------
    // If clicking currently selected option
    // ---------------------------------------------------
    if (isActive) {
      if (valueSpan) {
        valueSpan.textContent =
          valueSpan.dataset.defaultValue ||
          valueSpan.textContent;
      }
      removeShopByFilter(filterType, selectedValue);
      return;
    }

    // ---------------------------------------------------
    // Select new option
    // ---------------------------------------------------
    shopByOption.classList.add('active');

    if (valueSpan) {

      if (!valueSpan.dataset.defaultValue) {
        valueSpan.dataset.defaultValue = valueSpan.textContent;
      }

      valueSpan.textContent = shopByOption.textContent.trim();
    }

    // ---------------------------------------------------
    // Find Shopify's actual filter input
    // ---------------------------------------------------

    const filterInput = document.querySelector(
      `input[name="${CSS.escape(filterType)}"][value="${CSS.escape(selectedValue)}"]`
    );

    if (!filterInput) {
      console.warn(
        'Shopify filter input not found:',
        filterType,
        selectedValue
      );
      return;
    }

    // ---------------------------------------------------
    // IMPORTANT:
    // Do NOT remove other active filters.
    //
    // Shopify will combine the checked filters.
    // ---------------------------------------------------

    if (filterInput.disabled) {
      filterInput.disabled = false;
    }

    filterInput.click();

  });


  function syncShopByFilters() {
    const params = new URLSearchParams(window.location.search);

    document.querySelectorAll('.custom_shop_by').forEach(function (dropdown) {
      const filterType = dropdown.dataset.filterType;

      if (!filterType) return;

      const urlValues = params.getAll(filterType);

      dropdown.querySelectorAll('.shopby_option').forEach(function (option) {
        const value = option.dataset.value;
        // const checkbox = option.querySelector('input[type="checkbox"]');

        if (!value) return;

        const isSelected = urlValues.includes(value);

        option.classList.toggle('active', isSelected);

        // if (checkbox) {
        //   checkbox.checked = isSelected;
        // }
      });
    });
  }


  // Initial load check and set current selected filter to be checked into shop by filter
  syncShopByFilters();

  const productGrid = document.querySelector('#ProductGridContainer');

  if (!productGrid) return;

  const observer = new MutationObserver(function (mutations) {
    const hasChanges = mutations.some(function (mutation) {
      return (
        mutation.type === 'childList' ||
        mutation.type === 'attributes'
      );
    });

    if (hasChanges) {
      syncShopByFilters();
    }
  });

  observer.observe(productGrid, {
    childList: true,
    subtree: true,
    attributes: true
  });

  // Remove only one specific Shop By filter
  function removeShopByFilter(filterType, selectedValue) {

    const filterInput = document.querySelector(
      `input[name="${CSS.escape(filterType)}"][value="${CSS.escape(selectedValue)}"]`
    );

    if (!filterInput) return;

    if (filterInput.checked) {
      if (filterInput.disabled) {
        filterInput.disabled = false;
      }
      filterInput.click();
    }
  }
});



// ------------------------------
// Update Main + Addon Price
// ------------------------------
function updateMainAndAddonPrice() {
  const mainPriceEl = document.querySelector(".main_and_chain_addon_price");
  const addonPriceEl = document.querySelector(".easify-product-options .po-priceSummary-price");
  const originalPriceEl = document.querySelector(".product_main_price_container");

  if (!mainPriceEl || !originalPriceEl) return;

  // No addon price available
  if (!addonPriceEl) {
    originalPriceEl.classList.remove("hidden");
    mainPriceEl.classList.add("hidden");
    return;
  }

  const mainPrice = parseFloat(
    (mainPriceEl.dataset.productMainPrice || "0").replace(/[^\d.]/g, "")
  ) || 0;

  const addonPrice = parseFloat(
    addonPriceEl.textContent.replace(/[^\d.]/g, "")
  ) || 0;

  const totalPrice = `$${(mainPrice + addonPrice).toFixed(2)}`;

  if (mainPriceEl.textContent.trim() !== totalPrice) {
    mainPriceEl.textContent = totalPrice;
  }

  originalPriceEl.classList.add("hidden");
  mainPriceEl.classList.remove("hidden");
}

// ------------------------------
// Observe Product Info Changes
// ------------------------------
function initPriceObserver() {
  const productInfo = document.querySelector(".product__info-container");

  if (!productInfo) return;

  let timeout;

  const runUpdate = () => {
    clearTimeout(timeout);
    timeout = setTimeout(updateMainAndAddonPrice, 100);
  };

  // Initial calculation
  runUpdate();

  const observer = new MutationObserver(runUpdate);

  observer.observe(productInfo, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
  });

  ["click", "change", "input"].forEach((event) => {
    productInfo.addEventListener(event, runUpdate);
  });
}

// ------------------------------
// Variant Selection
// ------------------------------
function initVariantSelection() {
  const chainNote = document.querySelector(".chain_note");
  const easifyOptions = document.querySelector(".shopify-app-block .easify-product-options");
  const pdpPriceRange = document.querySelector(".pdp_price_range");
  const atcBtn = document.querySelector(".buy-btn-pro .product-form__buttons .product-form__submit");
  const varOptions = document.querySelectorAll(".product_variants_container .variant_option");

  if (!varOptions.length) return;

  // Initial state
  atcBtn?.classList.add("disabled");
  if (atcBtn) atcBtn.disabled = true;

  easifyOptions?.classList.add("hidden");

  varOptions.forEach((option) => {
    option.checked = false;

    option.addEventListener("change", () => {
      pdpPriceRange?.classList.add("hidden");

      if (atcBtn) {
        atcBtn.disabled = false;
        atcBtn.classList.remove("disabled");
      }

      easifyOptions?.classList.remove("hidden");
      chainNote?.classList.add("hidden");

      updateMainAndAddonPrice();
    });
  });

  // If a variant is already selected
  const selectedVariant = document.querySelector(
    ".product_variants_container .variant_option:checked"
  );

  selectedVariant?.dispatchEvent(new Event("change"));
}

// ------------------------------
// Initialise
// ------------------------------
function initProductPage() {
  initVariantSelection();
  initPriceObserver();
  updateMainAndAddonPrice();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProductPage);
} else {
  initProductPage();
}

// gift ideas
document.addEventListener("DOMContentLoaded", (event) => {
  const giftIdeaOptions = document.querySelector('.gift_collection_options');
  if (giftIdeaOptions) {
    giftIdeaOptions.addEventListener('change', function () {
      const selectedGift = this.value;

      manageGiftIdeas();
      const showSelectedGift = document.querySelector(`.coll_${selectedGift}`);
      showSelectedGift.classList.remove('hidden');
    });
  }

  function manageGiftIdeas() {
    const allGiftIdeas = document.querySelectorAll('.collection_products');
    allGiftIdeas.forEach((giftIdes) => {
      giftIdes.classList.add('hidden');
    });
  }
});

// filter active or not manage empty state
function manageActiveFacets() {
  const status = document.querySelector('.js-active-filter-status');
  const desktopActiveFacets = document.querySelector(
    '.active-facets.active-facets-desktop.manage_empty_state'
  );
  const mobileActiveFacets = document.querySelector(
    '.active-facets.active-facets-mobile.mobile_active_filter_state'
  );

  if (status) {

    const hasActiveFilters = status.dataset.activeFilter === 'true';
    if (desktopActiveFacets) {
      desktopActiveFacets.classList.toggle('hidden', !hasActiveFilters);
    }
    if (mobileActiveFacets) {
      mobileActiveFacets.classList.toggle('hidden', !hasActiveFilters);
    }
  }

}

document.addEventListener('DOMContentLoaded', () => {
  manageActiveFacets();

  new MutationObserver(() => {
    manageActiveFacets();
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
});





// setTimeout(() => {
//   document.querySelectorAll(".po-toggle-root").forEach((toggle) => {
//     const label = toggle.parentElement?.querySelector(".po-switch-label");

//     if (!label) return;

//     // Set initial text based on current class
//     updateLabel(toggle, label);

//     // Toggle on click
//     toggle.addEventListener("click", () => {
//       if (toggle.classList.contains("po-toggle-on")) {
//         toggle.classList.remove("po-toggle-on");
//         toggle.classList.add("po-toggle-off");
//       } else {
//         toggle.classList.remove("po-toggle-off");
//         toggle.classList.add("po-toggle-on");
//       }

//       updateLabel(toggle, label);
//     });
//   });

//   function updateLabel(toggle, label) {
//     if (toggle.classList.contains("po-toggle-off")) {
//       label.textContent = "No";
//     } else if (toggle.classList.contains("po-toggle-on")) {
//       label.textContent = "Yes";
//     }
//   }
// }, 1500);


(() => {
  function updateLabel(toggle) {
    const label = toggle.parentElement?.querySelector(".po-switch-label");

    if (!label) return;

    if (toggle.classList.contains("po-toggle-off")) {
      label.textContent = "No";
    } else if (toggle.classList.contains("po-toggle-on")) {
      label.textContent = "Yes";
    }
  }

  function observeToggle(toggle) {
    updateLabel(toggle);

    // Watch only this toggle's class changes
    if (toggle.dataset.labelObserverAttached) return;

    toggle.dataset.labelObserverAttached = "true";

    const observer = new MutationObserver(() => {
      updateLabel(toggle);
    });

    observer.observe(toggle, {
      attributes: true,
      attributeFilter: ["class"]
    });
  }

  function processNode(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;

    if (node.matches?.(".po-toggle-root")) {
      observeToggle(node);
    }

    node.querySelectorAll?.(".po-toggle-root").forEach(observeToggle);
  }

  // Existing toggles
  document.querySelectorAll(".po-toggle-root").forEach(observeToggle);

  // Detect toggles created by the app
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(processNode);
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


